<template>
  <div class="home">
    <div class="flex content-center mt-40">
      <div class="text-left flex-grow">
        <h3 class="font-extrabold text-black text-3xl">Hello, I'm Dimas Adi.</h3>
        <p class="pt-4">A <a class="text-teal-500">fullstack developer & student</a> who is enthusiastic <br/>about technological developments.</p>
        <button class="bg-black .button hover:bg-white hover:text-black border hover:border-black text-white font-bold py-4 mt-6 px-8 inline-flex items-center">
          About Me
        </button>
      </div>
      <div class="flex-grow h3 mt-8 ml-2 text-white text-left">
       
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {  }
};
</script>